import { useEffect, useRef, useState } from "react";
import { useViewContext } from "../../../../../context/View/ViewContext";
import useGetCensusParams from "../controls/GetCensusParams";
import MessagesContainer from "../../../messages/messageContainer";

const GbCensusMessages = () => {
  const { outputAreaId, year, categoryId, columnId } = useGetCensusParams();
  const [label, setLabel] = useState("");
  const [visible, setVisible] = useState(false);

  const { view } = useViewContext();
  const labelTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const setLabelDebounced = (next: string) => {
    if (labelTimerRef.current) clearTimeout(labelTimerRef.current);
    labelTimerRef.current = setTimeout(() => setLabel(next), 500);
  };

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!view) return;

    const updateLabel = () => {
      const zoom = view.getZoom() ?? 0;
      if (!year) {
        setLabelDebounced("Please select a year to view census boundaries");
        return;
      }

      if (outputAreaId == null) {
        setLabelDebounced(
          "Please select an output area type to view census boundaries",
        );
        return;
      }

      if (zoom < 12) {
        setLabelDebounced("Please zoom in to view census boundaries");
        return;
      }

      if (categoryId == null) {
        setLabelDebounced(
          "A category must be selected before you can click the map to view data.",
        );
        return;
      }

      if (columnId == null) {
        setLabelDebounced(
          "A column must be selected before you can click the map to view data.",
        );
        return;
      }

      setLabelDebounced("");
    };

    updateLabel();

    view.on("change:resolution", updateLabel);

    return () => {
      view.un("change:resolution", updateLabel);
      if (labelTimerRef.current) clearTimeout(labelTimerRef.current);
    };
  }, [view, year, outputAreaId, categoryId, columnId]);

  return (
    <>
      {label && visible && (
        <MessagesContainer>
          <div className="rounded bg-light text-black text-center p-2">
            {label}
          </div>
        </MessagesContainer>
      )}
    </>
  );
};

export default GbCensusMessages;
